import { makeAutoObservable } from 'mobx';
interface IcommonStore {
  count: number
}

class recentStore implements IcommonStore {

  constructor() {
    makeAutoObservable(this);
  }

  updateState = (params: { [key: string]: any }) => {
    for (const [key, value] of Object.entries(params)) {
      (this as any)[key] = value;
    }
  };

  count = 0;

}

export default new recentStore();